// Central content + asset registry for Genuine Forge

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/76c18577-5d8a-424d-8f7c-e46b19b2d396/images/b36b62b1a797936a77bbd7aeda9b91722581f4f1606476e06dfc4903e9c39a39.jpeg",
  rtu: "https://static.prod-images.emergentagent.com/jobs/76c18577-5d8a-424d-8f7c-e46b19b2d396/images/fffe150ba715e7afea0b0a1c5f5eef0ce48f14cd0cc0b54325d0733dac19ca26.jpeg",
  mechanicalRoom: "https://static.prod-images.emergentagent.com/jobs/76c18577-5d8a-424d-8f7c-e46b19b2d396/images/22758dd5b47f014d214833ce632f13dc02567c3e5a35591e1f10576c041413c6.jpeg",
  furnace: "https://static.prod-images.emergentagent.com/jobs/76c18577-5d8a-424d-8f7c-e46b19b2d396/images/2dae2fca320bbeec6444f2bea212c888b86a3a6618076900c42e967cebfc8658.jpeg",
  acInstall: "https://static.prod-images.emergentagent.com/jobs/76c18577-5d8a-424d-8f7c-e46b19b2d396/images/e672863c46254fe57237ada40c4f9e87b1dfba9793f7763e531fa49b03e603af.jpeg",
  diagnostics: "https://static.prod-images.emergentagent.com/jobs/76c18577-5d8a-424d-8f7c-e46b19b2d396/images/d5ba8f12d27e24f6be6ef0286e41b1f33be9fed6f107df6b7998340b0504d9e0.jpeg",
  rooftopStock: "https://images.unsplash.com/photo-1774290331891-5d759056c68d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  crane: "https://images.unsplash.com/photo-1553048686-e3d0396506b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ductwork: "https://images.pexels.com/photos/31772935/pexels-photo-31772935.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const CONTACT = {
  phone: "773-931-7012",
  phoneRaw: "7739317012",
  email: "Contact@genuineforge.com",
  location: "Chicago, Illinois",
  radius: "~20-mile service radius",
};

export const SERVICES = [
  {
    slug: "hvac-service",
    index: "01",
    title: "HVAC Diagnostics & Repair",
    short: "Precision troubleshooting — not guesswork.",
    image: IMAGES.diagnostics,
    span: "lg:col-span-7",
    points: ["Furnace & no-heat diagnostics", "AC diagnostics", "Electrical troubleshooting", "Airflow problems", "Control board faults", "Blower & inducer problems", "Capacitors & motors", "Thermostat & refrigeration"],
  },
  {
    slug: "furnace-installation",
    index: "02",
    title: "Furnace Installation & Replacement",
    short: "We engineer the installation around the building.",
    image: IMAGES.furnace,
    span: "lg:col-span-5",
    points: ["High-efficiency furnaces", "Proper sizing & airflow", "Gas piping & venting", "Startup verification", "Clean installation standards", "Documented handoff"],
  },
  {
    slug: "ac-installation",
    index: "03",
    title: "Air Conditioning Installation",
    short: "Matched systems built for long-term reliability.",
    image: IMAGES.acInstall,
    span: "lg:col-span-5",
    points: ["Condensers & evaporator coils", "Matched systems", "Refrigerant setup", "Electrical & drainage", "Startup & commissioning"],
  },
  {
    slug: "light-commercial-hvac",
    index: "04",
    title: "Light Commercial HVAC",
    short: "Commercial HVAC without the residential guesswork.",
    image: IMAGES.rtu,
    span: "lg:col-span-7",
    points: ["Rooftop units & RTU change-outs", "3–25 ton systems", "Crane-coordinated replacements", "Duct & gas modifications", "Property management support", "GC / subcontract support"],
  },
];

export const PROCESS = [
  { n: "01", title: "Diagnose", body: "Understand the actual problem using measurable data — pressure, temperature, current, and airflow." },
  { n: "02", title: "Explain", body: "Clear findings, honest options, and transparent pricing before any work begins." },
  { n: "03", title: "Execute", body: "Repair or install with professional workmanship and clean installation standards." },
  { n: "04", title: "Verify", body: "Startup, testing, and a documented handoff so the system performs as engineered." },
];

export const WHY = [
  "Engineering-driven diagnostics",
  "Clean installation standards",
  "Clear scope and pricing",
  "Professional documentation",
  "Reliable communication",
  "Residential & light commercial capability",
  "Installation-focused expertise",
  "Modern diagnostic technology",
  "One-year labor warranty where applicable",
];

export const DIAGNOSTIC_TOOLS = [
  { label: "Digital manometers", metric: "PRESSURE", unit: "in. WC" },
  { label: "Temperature probes", metric: "TEMP RISE", unit: "°F" },
  { label: "Electrical testing", metric: "CURRENT / VOLTAGE", unit: "A / V" },
  { label: "Combustion analysis", metric: "COMBUSTION", unit: "ppm / %" },
  { label: "Airflow diagnostics", metric: "AIRFLOW", unit: "CFM" },
  { label: "Refrigerant diagnostics", metric: "REFRIGERANT", unit: "psi" },
];

export const TESTIMONIALS = [
  { quote: "Genuine Forge diagnosed a control issue two other companies missed. Clear documentation, clean work, no drama.", name: "D. Whitfield", role: "Property Manager · West Loop", tag: "Property Management" },
  { quote: "We use them for RTU change-outs across our portfolio. On schedule, crane coordination handled, clean handoff every time.", name: "M. Alvarez", role: "General Contractor", tag: "Contractor Partner" },
  { quote: "Honest diagnosis on a no-heat call during a cold snap. Explained the options and fixed it right the first time.", name: "S. Kowalski", role: "Homeowner · Lincoln Park", tag: "Residential" },
  { quote: "The install quality is a step above. Gas piping and venting were textbook, and they left the mechanical room spotless.", name: "R. Chen", role: "Building Owner", tag: "Light Commercial" },
];

export const GALLERY = [
  { image: IMAGES.rtu, title: "RTU Change-Out", spec: "12.5 TON · PACKAGED UNIT", tag: "Commercial" },
  { image: IMAGES.furnace, title: "High-Efficiency Furnace", spec: "96% AFUE · 2-STAGE", tag: "Residential" },
  { image: IMAGES.mechanicalRoom, title: "Mechanical Room Build", spec: "COPPER · CLEAN ROUTING", tag: "Commercial" },
  { image: IMAGES.acInstall, title: "Condenser Replacement", spec: "MATCHED SYSTEM · R-410A", tag: "Residential" },
  { image: IMAGES.crane, title: "Crane-Coordinated Lift", spec: "ROOFTOP · SCHEDULED", tag: "Commercial" },
  { image: IMAGES.ductwork, title: "Duct Modification", spec: "AIRFLOW BALANCED", tag: "Light Commercial" },
];

// Sub-page configs
export const SERVICE_PAGES = {
  "hvac-service": {
    eyebrow: "SERVICE / DIAGNOSTICS",
    title: "HVAC Service & Diagnostics",
    lede: "Precision troubleshooting for furnaces, air conditioning, and controls. We measure the system, isolate the fault, and fix the root cause.",
    image: IMAGES.diagnostics,
    seo: "furnace repair Chicago, AC repair Chicago, HVAC service Chicago",
    blocks: [
      { h: "We diagnose systems. We don't guess at them.", p: "No-heat calls, intermittent faults, and airflow problems are solved with data — pressure, temperature, current, voltage, and fault-code analysis — not part-swapping.", list: ["Furnace & no-heat diagnostics", "AC diagnostics", "Electrical troubleshooting", "Airflow problems", "Control board faults", "Blower & inducer problems", "Capacitors & motors", "Thermostat & refrigeration diagnostics"] },
    ],
  },
  "furnace-installation": {
    eyebrow: "INSTALLATION / REPLACEMENT",
    title: "Furnace Installation & Replacement",
    lede: "High-efficiency furnace installations engineered around your building — proper sizing, airflow, gas piping, and venting done to standard.",
    image: IMAGES.furnace,
    seo: "furnace installation Chicago",
    blocks: [
      { h: "We don't just replace equipment. We engineer the installation.", p: "Every furnace is sized to the load and matched to the duct system. Startup is verified and documented so the system performs the way it was designed to.", list: ["High-efficiency furnaces", "Proper sizing & load calculation", "Airflow considerations", "Gas piping & venting", "Startup verification", "Clean installation standards", "Documented handoff"] },
    ],
  },
  "ac-installation": {
    eyebrow: "INSTALLATION / REPLACEMENT",
    title: "Air Conditioning Installation & Replacement",
    lede: "Matched cooling systems installed for long-term reliability — condensers, coils, refrigerant, electrical, drainage, and commissioning.",
    image: IMAGES.acInstall,
    seo: "AC installation Chicago",
    blocks: [
      { h: "Proper installation is the difference in long-term reliability.", p: "A cooling system is only as good as its installation. We match components, set refrigerant charge correctly, and commission the system on startup.", list: ["Condensers & evaporator coils", "Matched systems", "Refrigerant setup & charge", "Electrical & drainage", "Startup & commissioning"] },
    ],
  },
  "light-commercial-hvac": {
    eyebrow: "LIGHT COMMERCIAL",
    title: "Light Commercial HVAC",
    lede: "Rooftop units, RTU change-outs, and 3–25 ton systems — installed cleanly and on schedule, without the residential guesswork.",
    image: IMAGES.rtu,
    seo: "commercial HVAC Chicago, light commercial HVAC contractor",
    blocks: [
      { h: "Light commercial HVAC without the residential guesswork.", p: "We support property managers, GCs, and building owners with crane-coordinated replacements, duct and gas modifications, and documented commissioning.", list: ["Rooftop units (RTUs)", "RTU change-outs", "3–25 ton systems", "Crane-coordinated replacements", "Commercial furnaces", "Duct & gas modifications", "Electrical coordination", "Startup & commissioning"] },
    ],
  },
  "rtu-change-outs": {
    eyebrow: "COMMERCIAL / ROOFTOP",
    title: "RTU Change-Outs",
    lede: "Rooftop unit change-outs done cleanly and on schedule — crane logistics, curb adaptation, and commissioning handled end to end.",
    image: IMAGES.rtu,
    seo: "rooftop unit replacement Chicago, RTU change-out Chicago",
    blocks: [
      { h: "RTU change-outs, done cleanly and on schedule.", p: "We coordinate the crane, protect the property, adapt the curb where needed, and commission the unit — with documentation for the building owner or GC.", list: ["Crane coordination & rigging", "Curb adaptation", "Gas & electrical reconnection", "Duct transitions", "Startup & commissioning", "Documented handoff"] },
    ],
  },
  "preventive-maintenance": {
    eyebrow: "MAINTENANCE",
    title: "Preventive Maintenance",
    lede: "Prevent failure before it becomes an emergency. Seasonal inspections built on measurement, not checkboxes.",
    image: IMAGES.mechanicalRoom,
    seo: "HVAC maintenance Chicago",
    blocks: [
      { h: "Prevent failure before it becomes an emergency.", p: "Our maintenance program measures the things that predict failure and documents the history of the system over time.", list: ["Seasonal inspection", "Airflow evaluation", "Filter condition", "Electrical checks", "Blower & inducer evaluation", "Temperature rise", "Pressure measurements", "Combustion review where applicable", "Maintenance history"] },
      { h: "Furnace Sentinel — innovation layer", p: "Advanced remote monitoring and predictive maintenance capabilities are under development through our Furnace Sentinel platform.", list: [] },
    ],
  },
  "technology-diagnostics": {
    eyebrow: "TECHNOLOGY",
    title: "Technology & Diagnostics",
    lede: "We diagnose systems. We don't guess at them. Genuine Forge uses measurable data to find the real fault.",
    image: IMAGES.diagnostics,
    seo: "HVAC diagnostics Chicago",
    blocks: [
      { h: "Measurable data, not guesswork.", p: "Modern connected tools let us measure pressure, temperature, current, voltage, airflow, system sequence, and fault codes — the same technical DNA behind our Furnace Sentinel platform.", list: ["Digital manometers", "Temperature probes", "Electrical testing", "Combustion analysis", "Airflow diagnostics", "Refrigerant diagnostics", "System data & fault codes"] },
    ],
  },
};
